import React, { useState, useEffect } from "react"

import { Image } from "antd"
function ImageComponent({ imageUrl, width = 30, height = 30, preview = true }) {
  const getEncodedS3Url = (path) => {
    if (!path) return ""

    try {
      const parts = path.split("/")
      const encodedParts = parts.map((part, index) => {
        // Sadece dosya adı olan son parçayı encode et
        return index === parts.length - 1 ? encodeURIComponent(decodeURIComponent(part)) : part
      })

      return `${encodedParts.join("/")}`
    } catch (e) {
      return `${path}`
    }
  }

  const encodedUrl = getEncodedS3Url(imageUrl)
  return (
    <Image width={width} height={height} src={encodedUrl} preview={preview} />
  )
}

export default ImageComponent
